import { canAccessOrgDashboard } from '../../utils/orgDashboard';
import useUser from '../auth/useUser';
import useAccount from './useAccount';

// Single source for the org dashboard gate: the nav entry, the route and the org queries
// (venues / types / accounts) all read it, so an account without the feature never fires
// those requests. Reads useAccount rather than ConfigContext so it also works above the
// ConfigContextProvider in AppShell.
const useCanAccessOrgDashboard = () => {
  const { isUbeyaAdmin } = useUser();
  const { config } = useAccount();

  return canAccessOrgDashboard({
    isUbeyaAdmin,
    organizationId: config?.organizationId,
    isOrganizationDashboardEnabled: config?.isOrganizationDashboardEnabled
  });
};

export default useCanAccessOrgDashboard;
